import { FeatureToggleClientService } from 'feature-toggle-client';
const NewApplicationMenuOrder = 'new-application-menu-order';
export class MenuItemActionFeatures {
    static async newApplicationMenuOrderEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(NewApplicationMenuOrder, false);
    }
}
